import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChartsModule } from 'ng2-charts';
import { AutoCompleteModule } from 'src/app/shared/auto-complete/autocomplete.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmployeeDashboardComponent } from './employee-dashboard/employee-dashboard.component';
import { MyProfileEditModalComponent } from './my-profile-edit-modal/my-profile-edit-modal.component';
import { MyProfileRoutingModule } from './my-profile-routing.module';
import { MyProfileSettingsComponent } from './my-profile-settings/my-profile-settings.component';
import { MyProfileComponent } from './my-profile.component';
import { StudentDashboardComponent } from './student-dashboard/student-dashboard.component';
import {
  EmployeeActivityDataListComponent
} from './employee-dashboard/employee-activity-data-list/employee-activity-data-list.component';
import { DataTableModule } from '../../shared/data-table/data-table.module';
import {
  EmployeeActivityInfoModalComponent
} from './employee-dashboard/employee-activity-data-list/employee-activity-info-modal/employee-activity-info-modal.component';

@NgModule({
  declarations: [
    MyProfileComponent,
    MyProfileEditModalComponent,
    MyProfileSettingsComponent,
    EmployeeDashboardComponent,
    StudentDashboardComponent,
    EmployeeActivityDataListComponent,
    EmployeeActivityInfoModalComponent
  ],
  imports: [CommonModule, MyProfileRoutingModule, SharedModule, AutoCompleteModule, ChartsModule, DataTableModule]
})
export class MyProfileModule {}
